var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big_box"},[_c('report-table-children',{attrs:{"api-config":_vm.apiConfig,"date-field":'billDateRange',"data-key":"data","show-pagination":true,"report-key":"PurcDailyRpt","filterMode":"drawer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }